module.exports = __webpack_public_path__ + "static/bg-a9542a427565e1aa5db10b3db582b1fd.png";